var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000000884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M34 29.7292C34.4815 29.7294 34.9445 29.8839 35.293 30.1608C35.6415 30.4378 35.8488 30.8158 35.8719 31.2166C35.895 31.6174 35.7323 32.0102 35.4173 32.3138C35.1023 32.6173 34.6593 32.8082 34.18 32.8469L34 32.8542H14C13.5185 32.854 13.0555 32.6994 12.707 32.4225C12.3585 32.1456 12.1512 31.7676 12.1281 31.3668C12.105 30.966 12.2677 30.5731 12.5827 30.2696C12.8977 29.9661 13.3407 29.7752 13.82 29.7365L14 29.7292H34ZM34 22.4375C34.4973 22.4375 34.9742 22.6021 35.3258 22.8951C35.6775 23.1882 35.875 23.5856 35.875 24C35.875 24.4144 35.6775 24.8118 35.3258 25.1049C34.9742 25.3979 34.4973 25.5625 34 25.5625H14C13.5027 25.5625 13.0258 25.3979 12.6742 25.1049C12.3225 24.8118 12.125 24.4144 12.125 24C12.125 23.5856 12.3225 23.1882 12.6742 22.8951C13.0258 22.6021 13.5027 22.4375 14 22.4375H34ZM34 15.1458C34.4973 15.1458 34.9742 15.3105 35.3258 15.6035C35.6775 15.8965 35.875 16.2939 35.875 16.7083C35.875 17.1227 35.6775 17.5202 35.3258 17.8132C34.9742 18.1062 34.4973 18.2708 34 18.2708H14C13.5027 18.2708 13.0258 18.1062 12.6742 17.8132C12.3225 17.5202 12.125 17.1227 12.125 16.7083C12.125 16.2939 12.3225 15.8965 12.6742 15.6035C13.0258 15.3105 13.5027 15.1458 14 15.1458H34Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.b9ff271ebf58c9594e8239604e0aa4df.svg";
export { ForwardRef as ReactComponent };